import { Observable, of } from 'rxjs';
import { LazyScrollableDataSource } from '@rappi/common';
import { AgencyRecognitionMethodOption, TaxPercentageOption } from '../../../models/makers-finances-mgr.models';

export type TooltipPosition = 'top' | 'right' | 'bottom' | 'left';

export interface SelectOptionTooltip {
  text: string;
  hover?: boolean;
  position?: TooltipPosition;
}

export interface SelectOption {
  id: string;
  name: string;
  // PR #38: when true the option is rendered disabled in the one-select (item[keys.disabled]).
  disabled?: boolean;
  // PR #38: tooltip shown on the option via the one-select itemTooltipTemplate (item[keys.tooltip]).
  tooltip?: SelectOptionTooltip;
}

export function staticSource(options: string[]): LazyScrollableDataSource<SelectOption> {
  const items: SelectOption[] = options.map(o => ({ id: o, name: o }));
  return new LazyScrollableDataSource<SelectOption>((): Observable<SelectOption[]> => of(items));
}

// Builds a select source from catalog items using the item code as value and name as label.
// The code is the stable identifier used as form value and Map key for ID resolution.
export function staticSourceFromCatalog(items: Array<{ code: string; name: string }>): LazyScrollableDataSource<SelectOption> {
  const opts: SelectOption[] = items.map(i => ({ id: i.code, name: i.name }));
  return new LazyScrollableDataSource<SelectOption>((): Observable<SelectOption[]> => of(opts));
}

export function staticSourceFromOptions(options: AgencyRecognitionMethodOption[]): LazyScrollableDataSource<SelectOption> {
  const items: SelectOption[] = options.map(o => ({ id: o.value, name: o.label }));
  return new LazyScrollableDataSource<SelectOption>((): Observable<SelectOption[]> => of(items));
}

export function staticSourceFromTaxOptions(options: TaxPercentageOption[]): LazyScrollableDataSource<SelectOption> {
  const items: SelectOption[] = options.map(o => ({ id: o.value, name: o.label }));
  return new LazyScrollableDataSource<SelectOption>((): Observable<SelectOption[]> => of(items));
}
